module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./VideoPunchView.js"));
	}, "VideoPunchView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=VideoPunchView!./src/pages/Learn/VideoPunch/VideoPunchView.js
// module id = 1243
// module chunks = 438